import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { FaCheck, FaCircleInfo, FaTriangleExclamation } from 'react-icons/fa6'
import { ImSpinner } from 'react-icons/im'
import { IoWarning } from 'react-icons/io5'

import { useDialogBox } from '../hooks/useDialogBox'

export function ConfirmationDialog() {
  const { dialogData, setIsOpen, isOpen, isLoadingDialogAction } = useDialogBox()

  async function handleConfirm() {
    if (!isLoadingDialogAction) {
      if (dialogData.action) {
        await dialogData.action()
      }
      setIsOpen(false)
    }
  }

  async function handleCancel() {
    if (!isLoadingDialogAction) {
      if (dialogData.cancelAction) {
        await dialogData.cancelAction()
      }
      setIsOpen(false)
    }
  }

  function handleClose(value: boolean) {
    if (!isLoadingDialogAction) {
      setIsOpen(value)
    }
  }

  return (
    <Dialog open={isOpen} onClose={handleClose} className="relative over-all">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg data-closed:sm:translate-y-0 data-closed:sm:scale-95"
          >
            <div className="flex items-center justify-between bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start min-w-full">
                <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-gray-200 sm:mx-0 sm:size-10">
                  {!dialogData.type
                    ? (
                      <FaTriangleExclamation aria-hidden="true" className="size-6 text-red-600" />
                      )
                    : (
                      <>
                        {dialogData.type === 'error' && (
                          <FaTriangleExclamation aria-hidden="true" className="size-6 text-red-600" />
                        )}
                        {dialogData.type === 'success' && (
                          <FaCheck aria-hidden="true" className="size-6 text-green-600" />
                        )}
                        {dialogData.type === 'warning' && (
                          <IoWarning aria-hidden="true" className="size-6 text-orange-600" />
                        )}
                        {dialogData.type === 'info' && (
                          <FaCircleInfo aria-hidden="true" className="size-6 text-indigo-600" />
                        )}
                      </>
                      )}
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <div className="flex flex-1">
                    <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                      {dialogData.title}
                    </DialogTitle>
                  </div>
                  <div className="mt-2">
                    {dialogData.content
                      ? (
                        <>
                          {dialogData.content}
                        </>
                        )
                      : (
                        <p className="text-sm text-gray-500">
                          {dialogData.description}
                        </p>
                        )}
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              {dialogData.showConfirmation && (
                <button
                  type="button"
                  onClick={handleConfirm}
                  className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 sm:ml-3 sm:w-auto disabled:bg-gray-500"
                  disabled={isLoadingDialogAction}
                >
                  {isLoadingDialogAction
                    ? (
                      <ImSpinner className="animate-spin" />
                      )
                    : (
                      <>
                        {dialogData.confirmButtonText || 'Confirmar'}
                      </>
                      )}
                </button>
              )}
              <button
                type="button"
                data-autofocus
                onClick={handleCancel}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                {dialogData.cancelButtonText || 'Fechar'}
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
